import { css } from '@emotion/react';
import { lighten } from '@mui/material';
import { css as globalCss, theme } from 'global';
import { noMargin } from 'global/globalCss';

export const paper = (selected, withPadding = true, clickable = true) => css`
  box-shadow: unset;
  padding: ${withPadding ? '16px' : '0'};
  margin: 8px 0;
  white-space: nowrap;
  border-radius: ${theme.radii.lg};
  background-color: ${selected
    ? lighten(theme.colors.primary.medium, 0.92)
    : theme.colors.white};
  ${clickable ? 'cursor: pointer;' : ''}
  border: 1px solid ${theme.colors.neutral[200]};
`;

export const paperContent = css`
  padding: 16px;
`;

export const date = css`
  font-weight: ${theme.fontWeights.medium};
  font-size: 0.88rem;
  line-height: 1.2857rem;
  margin-bottom: 4px;
  margin-top: 0;
  color: ${theme.colors.neutral[600]};
`;

export const summary = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 1em;
  line-height: 1.2em;
`;

export const customerDetails = (isCustomerCard) => css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: ${isCustomerCard ? 'space-between' : 'flex-end'};
  overflow: hidden;
  white-space: nowrap;
  color: ${theme.colors.neutral[500]};
  > p {
    margin: 8px 0 0;
  }
  > p:first-of-type {
    margin: 0;
  }
`;

export const orderDetails = css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  color: ${theme.colors.primary.dark};
  margin-left: 8px;
  > p {
    margin: 0px;
  }
`;

export const orderExpiry = css`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 8px 16px;
  background-color: ${theme.colors.neutral[50]};

  > p {
    color: ${theme.colors.neutral[500]};

    ${noMargin}
  }
`;

export const label = css`
  margin: 8px auto 0;
`;

export const showMoreIcon = css`
  background-color: ${theme.colors.neutral[50]};
  border-radius: 16px;
  height: 24px;
  width: 24px;
  padding: 5px 6px;
  margin-left: 8px;
`;

export const row = (alignItems = 'flex-start') => css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: ${alignItems};
`;

export const column = (fullWidth, ellipsisOverflow) => css`
  display: flex;
  flex-direction: column;
  ${fullWidth ? 'width: 100%;' : ''}
  ${ellipsisOverflow ? globalCss.ellipsisOverflow : ''}
`;

export const checkbox = css`
  width: 36px;
  margin-right: 18px;

  &:hover {
    cursor: pointer;
  }
`;

export const userDescription = css`
  margin-top: 0;
  ${globalCss.ellipsisOverflow}
`;

export const actions = css`
  display: flex;
  align-items: flex-start;

  & > div:not(:first-of-type) {
    margin-left: 16px;
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const separator = (selected) => css`
  border-bottom: 1px solid ${theme.colors.neutral[selected ? 300 : 200]};
  margin-bottom: 8px;
`;

export const switchContent = css`
  display: flex;
  align-items: center;
`;

export const toggle = css`
  margin-left: 0;

  & .MuiFormControlLabel-label {
    font-size: ${theme.fontSizes.body4};
    line-height: ${theme.lineHeights.body4};
  }
`;

export const tooltip = css`
  display: inline-flex;

  svg {
    margin-right: 4px;
    width: 1rem;
    height: 1rem;
  }
`;
